/*!

=========================================================
* Vue Argon Dashboard - v1.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/vue-argon-dashboard
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/vue-argon-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import axios from 'axios'
import axios from "./axiosHelper";
import "./registerServiceWorker";
import VueSweetalert2 from "vue-sweetalert2";
import VueScrollTo from "vue-scrollto";
import ArgonDashboard from "./plugins/argon-dashboard";
import wysiwyg from "vue-wysiwyg";
import { ClientTable } from "vue-tables-2";
import Embed from "v-video-embed";
import CKEditor from "ckeditor4-vue";

Vue.config.productionTip = false;
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VeeValidate from "vee-validate";
import { Validator } from "vee-validate";

// Import Bootstrap an BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css?t=1729327061";
import "bootstrap-vue/dist/bootstrap-vue.css?t=1729327061";
import "@/assets/css/ext/style.css?t=1729327061";
import "sweetalert2/dist/sweetalert2.min.css?t=1729327061";
import "vue-wysiwyg/dist/vueWysiwyg.css?t=1729327061";

axios.defaults.baseURL = "https://daring.api.pkbm-binapandumandiri.or.id/api";
// axios.defaults.baseURL = "http://127.0.0.1:8001/api"; // local dev
// axios.defaults.baseURL = 'https://daring.api.tesaplikasi.com/api';
// axios.defaults.baseURL = 'http://daring-api.com/api';
// axios.defaults.baseURL = 'http://localhost/pkbm-be/api';
// axios.defaults.baseURL = "http://127.0.0.1:8000/api";
// axios.defaults.raporUrl = 'http://localhost:4200';
axios.defaults.raporUrl = "https://rapor.pkbm-binapandumandiri.or.id";
axios.defaults.timeout = 10000;

Vue.use(Embed);
Vue.use(ClientTable, {}, false, "bootstrap4");
Vue.use(wysiwyg, {
  hideModules: {
    image: true,
    table: true,
    link: true,
    code: true,
    removeFormat: true,
    separator: true,
  },
});
Vue.use(VueSweetalert2);
Vue.use(CKEditor);

Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: "veeFields",
});
const dictionary = {
  id: {
    messages: {
      required: (field) => `${field} tidak boleh kosong`,
      email: (field) => `${field} belum benar`,
      confirmed: (field) => `${field} belum sesuai`,
      max_value: (field, value) => `${field} tidak boleh lebih dari ${value}`,
    },
  },
};
Validator.localize("id"); // changes the locale
// Merges the English dictionary and sets the current locale to English.
Validator.localize("id", dictionary.id);
// Merges all defined languages in the dictionary but does not set the current locale.
Validator.localize(dictionary);

Vue.use(ArgonDashboard);
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(VueScrollTo, {
  duration: 1000,
  offset: 0,
  force: true,
  cancelable: true,
  x: false,
  y: true,
});
Vue.mixin({
  methods: {
    errorValidate(error, scope = null) {
      for (const prop in error.data) {
        if (scope) {
          this.errors.add({
            scope: scope,
            field: prop,
            msg: `${error.data[prop]}`,
          });
        } else {
          this.errors.add({
            field: prop,
            msg: `${error.data[prop]}`,
          });
        }
      }
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    setCurrentSubjectId(subjectId) {
      this.$store.dispatch("setCurrentSubjectId", { subjectId });
    },
    setCurrentModulId(modulId) {
      this.$store.dispatch("setCurrentModulId", { modulId });
    },
  },
});

// Handle service worker updates
document.addEventListener("swUpdated", (event) => {
  const registration = event.detail;

  // Optionally show a prompt to the user before reloading the page
  if (confirm("New version available. Reload the page to update?")) {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
      window.location.reload(); // Force reload to get the latest version
    }
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
